import { Redo, Undo } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { Editor } from "@tiptap/react";
import { useEffect, useState } from "react";

interface HistoryProps {
    editor: Editor;
    mode: number;
}

export default function NoteHistory({ editor, mode }: HistoryProps) {
    const [canUndo, setCanUndo] = useState(false);
    const [canRedo, setCanRedo] = useState(false);

    useEffect(() => {
        const updateHistoryState = () => {
            setCanUndo(editor.can().undo());
            setCanRedo(editor.can().redo());
        };

        editor.on('update', updateHistoryState);

        return () => {
            editor.off('update', updateHistoryState);
        };
    }, [editor]);

    const handleUndo = () => {
        editor.commands.undo();
        setCanUndo(false);
    };

    const handleRedo = () => {
        editor.commands.redo();
        setCanRedo(false);
    };
    
    return (
        <>
            <Tooltip title="Undo">
                <IconButton
                    size="small"
                    onClick={handleUndo}
                    disabled={!canUndo}
                    sx={{ color: mode === 1 ? 'inherit' : 'white' }}
                >
                    <Undo sx={{ fontSize: 18 }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Redo">
                <IconButton
                    size="small"
                    onClick={handleRedo}
                    disabled={!canRedo}
                    sx={{ color: mode === 1 ? 'inherit' : 'white' }}
                >
                    <Redo sx={{ fontSize: 18 }} />
                </IconButton>
            </Tooltip>
        </>
    );
}
